module.exports = __webpack_public_path__ + "img/1.a80c724a.jpg";